const TemaList = () => import("~/components/Views/Prova/Tema/List");
const TemaNew = () => import("~/components/Views/Prova/Tema/New");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Classificação", link: "" }
];

export const tema = [
  {
    path: "classificacao/tema",
    component: TemaList,
    name: "Tema",
    meta: {
      title: "Tema",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "classificacao/tema/new",
    component: TemaNew,
    name: "Novo Tema",
    meta: {
      title: "Novo Tema",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "classificacao/tema/:id",
    component: TemaNew,
    name: "Alterar Tema",
    meta: {
      title: "Alterar Tema",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/classificacao/tema.js